import React, { useEffect } from 'react';
import { Box } from 'reflexbox';
import { SubHeader } from '../../../healtheraComponents';
import Switch from '../../Shared/Switch';
import { useDispatch } from 'react-redux';
import * as branchActions from '../../../redux/branches';
import MedpointIntegrationForm from './MedpointIntegrationForm';

export default function ThirdPartyIntegrationSettings({ integrations, pharmacyId }) {
  const { apotec, cegedim, titan, medpoint, propel } = integrations;

  const dispatch = useDispatch();

  useEffect(() => {
    if (medpoint) dispatch(branchActions.getMedpointIntegration(pharmacyId));
  }, [medpoint, dispatch, pharmacyId]);

  const handleChange = type => event => {
    dispatch(branchActions.updateBranch(pharmacyId, { integrations: { [type]: event.target.checked } }));
  };

  return (
    <>
      <Box>
        <SubHeader title='Third Party Integrations' />
      </Box>
      <Box ml={2}>
        <SubHeader title='PMR' />
        <Switch
          label='Apotec'
          onChange={handleChange('apotec')}
          checked={!!apotec}
        />
        <Switch
          label='Cegedim'
          onChange={handleChange('cegedim')}
          checked={!!cegedim}
        />
        <Switch
          label='Titan'
          onChange={handleChange('titan')}
          checked={!!titan}
        />
        <Switch
          label='Propel (Canada)'
          onChange={handleChange('propel')}
          checked={!!propel}
        />
      </Box>
      <Box ml={2}>
        <SubHeader title='Other' />
        <Switch
          label='Medpoint Collection Point'
          onChange={handleChange('medpoint')}
          checked={!!medpoint}
        />
        { !!medpoint && (<MedpointIntegrationForm pharmacyId={pharmacyId} /> )}
      </Box>
    </>
  )
}
